// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1___9ee2a249647137b92f8","cls2":"PaperImages-cls2__f75bad42708d9acac758 PaperImages-cls1___9ee2a249647137b92f8"};